import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-help-additional',
    templateUrl: './help-additional.component.html',
    styleUrls: ['./help-additional.component.css'],
    standalone: false
})
export class HelpAdditionalComponent implements OnInit {

  // PSMFC email
  @Input() email: string = "";

  constructor() {

  }

  ngOnInit(): void {

  }

}
